// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LinkElement_wrap__16afU"};